<app-nav-bar></app-nav-bar>
<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<div class="container">
  <div class="container-client">
    <div class="header">
      <h1 class="title">{{'NEW_CLIENT' | translate}}</h1>
      <app-back-arrow [route]="'/clients'" *ngIf="!dialogRef"></app-back-arrow>
    </div>
    <div class="form-card">
      <div class="loading" *ngIf="loading">
        <div class="spinner-border" role="status"></div>
      </div>
      <form
        *ngIf="!loading"
        #clientFormContainer
        [formGroup]="clientForm"
        (ngSubmit)="createClient()"
        class="content compact-form client-form-grid"
      >
        <section class="form-section">
          <h2 class="section-title">{{ 'PERSONAL_DATA' | translate }}</h2>
          <div class="section-grid">
            <div class="form-field">
              <label class="form-label is-required" for="firstName">{{'NAME' | translate}}</label>
              <input class="form-control" id="firstName" formControlName="firstName" type="text" [class.is-invalid]="clientForm.get('firstName')?.invalid && clientForm.get('firstName')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('firstName')?.hasError('required') && clientForm.get('firstName')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('NAME' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('firstName')?.hasError('minlength') && clientForm.get('firstName')?.touched">
                {{ 'CLIENT_FIELD_MINIMUM_LENGTH' | translate:{ field: ('NAME' | translate), length: 2 } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label is-required" for="lastName">{{'LAST_NAME' | translate}}</label>
              <input class="form-control" id="lastName" formControlName="lastName" type="text" [class.is-invalid]="clientForm.get('lastName')?.invalid && clientForm.get('lastName')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('lastName')?.hasError('required') && clientForm.get('lastName')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LAST_NAME' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('lastName')?.hasError('minlength') && clientForm.get('lastName')?.touched">
                {{ 'CLIENT_FIELD_MINIMUM_LENGTH' | translate:{ field: ('LAST_NAME' | translate), length: 2 } }}
              </div>
            </div>

            <div class="form-field" *ngIf="themingService.shopTheming[0].shopId === 4 || themingService.shopTheming[0].shopId === 12">
              <label class="form-label is-required" for="employeeId">{{'EMPLOYEE_ID' | translate}}</label>
              <input class="form-control" id="employeeId" formControlName="employeeId" type="text">
            </div>

            <div class="form-field">
              <label class="form-label" for="gender">{{'GENDER' | translate}}</label>
              <div class="radio-row">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="gender" id="genderMale" formControlName="gender" value="male">
                  <label class="form-check-label" for="genderMale">{{'MALE' | translate}}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="gender" id="genderFemale" formControlName="gender" value="female">
                  <label class="form-check-label" for="genderFemale">{{ 'FEMALE' | translate}}</label>
                </div>
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="bornDate">{{ 'BIRTH_DATE' | translate }}</label>
              <mat-form-field appearance="fill" class="w-100 client-date-field">
                <mat-label>{{ 'CHOOSE_DATE' | translate }}</mat-label>
                <input matInput id="bornDate" [matDatepicker]="bornDatePicker" formControlName="bornDate" [max]="bornDateMaxDate" [class.is-invalid]="clientForm.get('bornDate')?.invalid && clientForm.get('bornDate')?.touched">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="bornDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #bornDatePicker></mat-datepicker>
              </mat-form-field>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('bornDate')?.hasError('invalidDate') && clientForm.get('bornDate')?.touched">
                {{ 'INVALID_BIRTH_DATE' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('bornDate')?.hasError('futureDate') && clientForm.get('bornDate')?.touched">
                {{ 'FUTURE_BIRTH_DATE_NOT_ALLOWED' | translate }}
              </div>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h2 class="section-title">{{ 'CONTACT' | translate }} / {{'DOCUMENT' | translate}}</h2>
          <div class="section-grid contact-grid">
            <div class="form-field">
              <label class="form-label is-required" for="email">{{ 'EMAIL' | translate}}</label>
              <input class="form-control" id="email" formControlName="email" type="email" [class.is-invalid]="clientForm.get('email')?.invalid && clientForm.get('email')?.touched">
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('email')?.hasError('required') && clientForm.get('email')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('EMAIL' | translate) } }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('email')?.hasError('email') && clientForm.get('email')?.touched">
                {{ 'INVALID_EMAIL_FORMAT' | translate }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="phone">{{'PHONE' | translate}}</label>
              <app-international-phone-input inputId="phone" formControlName="phone"></app-international-phone-input>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('required') && clientForm.get('phone')?.touched">
                {{ 'PHONE_REQUIRED' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('phoneInvalid') && clientForm.get('phone')?.touched">
                {{ 'INVALID_PHONE_FORMAT' | translate }}
              </div>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('phone')?.hasError('countryCodeRequired') && clientForm.get('phone')?.touched">
                {{ 'COUNTRY_CODE_REQUIRED' | translate }}
              </div>
            </div>
            
            <div class="form-field">
              <label class="form-label is-required" for="documentType">{{'DOCUMENT_TYPE' | translate}}</label>
              <select class="form-select" id="documentType" formControlName="documentType" [class.is-invalid]="clientForm.get('documentType')?.invalid && clientForm.get('documentType')?.touched">
                <option value="" disabled>{{'SELECT_DOCUMENT_TYPE' | translate}}</option>
                <option value="ID">{{'ID_NUMBER' | translate}}</option>
                <option value="Passport">{{'PASSPORT' | translate}}</option>
                <option value="DIMEX">DIMEX</option>
                <option value="other">{{'OTHER' | translate}}</option>
              </select>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('documentType')?.hasError('required') && clientForm.get('documentType')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('DOCUMENT_TYPE' | translate) } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="nationalId">
                {{ clientForm.get('documentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (clientForm.get('documentType')?.value === 'DIMEX' ? 'DIMEX' : (clientForm.get('documentType')?.value === 'other' ? ('OTHER_IDENTIFICATION' | translate) : ('ID_NUMBER' | translate))) }}
              </label>
              <input class="form-control" [class.is-invalid]="(clientForm.get('nationalId')?.invalid && clientForm.get('nationalId')?.touched) || nationalIdInvalid" type="text" id="nationalId" formControlName="nationalId" [attr.placeholder]="placeholderText" [disabled]="!clientForm.get('documentType')?.value" [ngClass]="{'border border-red-500': nationalIdInvalid}" />
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('nationalId')?.hasError('required') && clientForm.get('nationalId')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('ID_NUMBER' | translate) } }}
              </div>
              <div *ngIf="nationalIdInvalid" class="invalid-feedback d-block">
                {{ 'INVALID_FORMAT' | translate:{ type: (clientForm.get('documentType')?.value === 'Passport' ? ('PASSPORT' | translate) : (clientForm.get('documentType')?.value === 'DIMEX' ? 'DIMEX' : (clientForm.get('documentType')?.value === 'other' ? ('OTHER_IDENTIFICATION' | translate) : ('ID_NUMBER' | translate)))) } }}
              </div>
            </div>
          </div>
        </section>

        <section class="form-section">
          <h2 class="section-title">{{ 'ACCESS' | translate }} / {{ 'ADDITIONAL_CONFIGURATION' | translate }}</h2>
          <div class="access-config-grid">
            <div class="form-field password-actions-column" *ngIf="shouldShowPasswordField()">
              <label class="form-label" for="password">{{ 'PASSWORD' | translate }}</label>
              <div class="pool-register position-relative">
                <input [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" formControlName="password" [class.is-invalid]="clientForm.get('password')?.invalid && clientForm.get('password')?.touched">
                <div class="password-actions">
                  <button type="button" class="btn btn-primary" [disabled]="clientForm.get('password')?.disabled" (click)="generatePassword()">{{ 'GENERATE' | translate }}</button>
                  <button type="button" class="btn btn-info" [disabled]="clientForm.get('password')?.disabled" (click)="togglePasswordVisibility()">{{ showPassword ? ('HIDE' | translate) : ('SHOW' | translate) }}</button>
                  <button type="button" class="btn btn-info" [disabled]="clientForm.get('password')?.disabled || !clientForm.get('password')?.value" (click)="copyPassword()">{{ 'COPY' | translate }}</button>
                </div>
                <div class="copy-feedback" *ngIf="passwordCopied">{{ 'COPIED' | translate }}</div>
                <div *ngIf="clientForm.get('password')?.touched && clientForm.get('password')?.errors as errors" class="password-errors-overlay">
                  <div *ngIf="errors?.['passwordStrength']?.hasUpperCase === false" class="error-message">{{ 'PASSWORD_ERROR_UPPERCASE' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasLowerCase === false" class="error-message">{{ 'PASSWORD_ERROR_LOWERCASE' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasNumber === false" class="error-message">{{ 'PASSWORD_ERROR_NUMBER' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.hasSpecialChar === false" class="error-message">{{ 'PASSWORD_ERROR_SPECIAL_CHAR' | translate }}</div>
                  <div *ngIf="errors?.['passwordStrength']?.isValidLength === false" class="error-message">{{ 'PASSWORD_MINIMUM_LENGTH' | translate }}</div>
                  <div *ngIf="errors?.['required']" class="error-message">{{ 'PASSWORD_REQUIRED' | translate }}</div>
                </div>
              </div>
            </div>

            <div class="switches-column">
              <label class="switch-item" for="isPoolRegister">
                <input class="form-check-input" id="isPoolRegister" formControlName="isPoolRegister" type="checkbox">
                <span>{{ 'ENABLE_ONLINE_PURCHASES' | translate }}</span>
              </label>
              <label class="switch-item">
                <mat-slide-toggle class="switch" id="isVerifiedClient" formControlName="isVerifiedClient"></mat-slide-toggle>
                <span>{{'ONLY_VERIFIED_USERS' | translate}}</span>
              </label>
            </div>

            <div class="form-field" *ngIf="shouldShowLoginMethod()">
              <label class="form-label is-required" for="loginMethod">{{ 'LOGIN_METHOD' | translate }}</label>
              <select class="form-select" id="loginMethod" formControlName="loginMethod" [class.is-invalid]="clientForm.get('loginMethod')?.invalid && clientForm.get('loginMethod')?.touched">
                <option *ngFor="let option of loginMethodOptions" [value]="option.value">
                  {{ option.labelKey | translate }}
                </option>
              </select>
              <div class="invalid-feedback d-block" *ngIf="clientForm.get('loginMethod')?.hasError('required') && clientForm.get('loginMethod')?.touched">
                {{ 'COMPONENT_FIELD_REQUIRED' | translate:{ field: ('LOGIN_METHOD' | translate) } }}
              </div>
            </div>

            <div class="form-field">
              <label class="form-label" for="clientSubscription">{{'SUBSCRIPTION' | translate}}</label>
              <select class="form-select" id="clientSubscription" formControlName="clientSubscription">
                <option value="">{{'NO_SUBSCRIPTION' | translate}}</option>
                <option *ngFor="let sub of clientSubscriptions" [value]="sub.clientSubscriptionId">{{sub.clientSubscriptionName}}</option>
              </select>
            </div>

            <div class="form-field">
              <label class="form-label" for="shopCompanyId">{{'ASSOCIATED_COMPANY' | translate}}</label>
              <select class="form-select" id="shopCompanyId" formControlName="shopCompanyId">
                <option [ngValue]="null">{{'NO_ASSOCIATED_COMPANY' | translate}}</option>
                <option *ngFor="let company of shopCompanies" [ngValue]="company.shopCompanyId">
                  {{ company.companyName }}
                </option>
              </select>
            </div>
          </div>
        </section>

        <div class="create-btn">
          <button class="btn primary-btn" type="submit">{{ 'CREATE_CLIENT' | translate }}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal client-confirm-modal" id="successClientModal" tabindex="-1">
    <div class="modal-dialog client-modal-dialog" role="document">
      <div class="modal-content client-modal-content">
        <div class="modal-body client-modal-body">
          <h3 class="text-center">{{'SUCCESS' | translate}}</h3>
          <p class="text-center">{{ 'CLIENT_REGISTERED_SUCCESS' | translate }}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal error-confirm-modal fade" id="requiredClientModal" tabindex="-1">
    <div class="modal-dialog error-modal-dialog" role="document">
      <div class="modal-content error-modal-content">
        <div class="modal-body error-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{ 'COMPLETE_REQUIRED_FIELDS' | translate }}</p>
          <p class="text-center">{{ 'PLEASE_REVIEW_THESE_FIELDS' | translate }}</p>
          <h4 class="required-fields-title">{{ 'REQUIRED_FIELDS_DETAIL_TITLE' | translate }}</h4>
          <ul class="invalid-fields-list">
            <li *ngFor="let field of invalidClientFields">{{ field.labelKey | translate }}</li>
          </ul>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal client-confirm-modal fade" id="errorClientModal" tabindex="-1">
    <div class="modal-dialog client-modal-dialog" role="document">
      <div class="modal-content client-modal-content">
        <div class="modal-body client-modal-body">
          <h3 class="text-center">{{'ERROR' | translate}}</h3>
          <p class="text-center">{{'ERROR_SAVING_CHANGES' | translate}}</p>
        </div>
        <div class="modal-buttons">
          <button type="button" class="btn btn-confirm" (click)="closeModal()">{{'CLOSE' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
